import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import productsReducer from './slices/productsSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    products: productsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['ui/setScrollPosition', 'products/setScrollPosition'],
      },
    }),
});

// TypeScript types (if using TypeScript)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

